import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { Servicio } from '../models/servicio';

@Injectable({
  providedIn: 'root'
})
export class ServicioService {


  constructor(private http: HttpClient) { }

  private servicios: Servicio[];
  private servicios$ = new Subject<Servicio[]>();

  private servicio: Servicio;
  private servicio$ = new Subject<Servicio>();

  change(val) {
    this.servicios = val;
    this.servicios$.next(this.servicios);
  }
  get$(): Observable<Servicio[]> {
    return this.servicios$.asObservable();
  }

  changeOne(val) {
    this.servicio = val;
    this.servicio$.next(this.servicio);
  }
  getOne$(): Observable<Servicio> {
    return this.servicio$.asObservable();
  }

  getAll(): Observable<Servicio[]> {
    return this.http.get(environment.apiUrl + 'servicio')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getFilter(data): Observable<Servicio[]> {

    return this.http.post(environment.apiUrl + 'servicio/getFilter', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }


  get(id) {
    return this.http.get(environment.apiUrl + 'servicio/' + id)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  add(data) {
    return this.http.post(environment.apiUrl + 'servicio', data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
  edit(data) {
    const apiUrl = environment.apiUrl + 'servicio';
    const url = `${apiUrl}/${data["id"]}`;


    return this.http.put(url, data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  delete(id) {

    return this.http.delete(environment.apiUrl + 'servicio/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }


  getTipo() {
    return this.http.get(environment.apiUrl + 'servicio/getTipo')
      .pipe(map((res: any) => {
        return res;
      }));
  }
  getSeccion() {
    return this.http.get(environment.apiUrl + 'servicio/getSeccion')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  changeImagePrincipal(formData: FormData, id): Observable<object> {
    return this.http.post(environment.apiUrl + 'servicio/changeImgPrincipal/' + id, formData)
      .pipe(
        map((res: any) => { return res.data; }),
        catchError(e => throwError(e))
      );
  }

  changeImageExtra(formData: FormData, id): Observable<object> {
    return this.http.post(environment.apiUrl + 'servicio/changeImgExtra/' + id, formData)
      .pipe(
        map((res: any) => { return res.data; }),
        catchError(e => throwError(e))
      );
  }

  deleteImg(id) {
    return this.http.delete(environment.apiUrl + 'servicio/deleteImg/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
}
